import React, { memo } from 'react'
import PropTypes from 'prop-types'

import { util } from '../../../util'
import { Icon } from '../index'

const Button = React.forwardRef(
    (
        {
            color,
            fontColor,
            disabled,
            variant,
            size,
            margin,
            inputProps,
            children,
            className,
            isRounded,
            ...rest
        },
        ref
    ) => {
        const btnClass = util.joinClasses(
            'btn',
            color && `btn-${color}`,
            fontColor && `font-${fontColor}`,
            size,
            margin,
            disabled && 'btn-disabled',
            !children && 'no-children',
            inputProps && 'icons',
            isRounded && 'is-rounded',
            variant,
            className
        )
        return (
            <button ref={ref} className={btnClass} disabled={disabled} {...rest}>
                {inputProps && inputProps.hasOwnProperty('start') && (
                    <span className={'btn__start'}>
                        <Icon
                            className={util.joinClasses(children && 'children', 'mt-1')}
                            size={'xs'}
                            renderIcon={inputProps['start']}
                        />
                    </span>
                )}
                {children && <span>{children}</span>}
                {inputProps && inputProps.hasOwnProperty('end') && (
                    <span className={'btn__end'}>
                        <Icon size={'xs'} renderIcon={inputProps['end']} />
                    </span>
                )}
            </button>
        )
    }
)

Button.propTypes = {
    /* color {String} -> describes the color of the button */
    color: PropTypes.oneOf(['transparent', 'primary', 'warning', 'light', 'disabled']),
    fontColor: PropTypes.oneOf(['primary', 'initial']),

    /* disabled {Boolean} -> if true then button will be disabled */
    disabled: PropTypes.bool,

    /* variant {String} -> (basic | null) */
    variant: PropTypes.string,

    /* size {String} -> describes the size of the button. */
    size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', 'xxl']),

    /* margin {String} -> look into (config.scss) for more info on margin configurations */
    margin: PropTypes.string,

    /* inputProps {Object} -> should consist either start or end to render icons fields. */
    inputProps: PropTypes.shape({
        /* Icon before button text */
        start: PropTypes.func,
        /* Icon After button text */
        end: PropTypes.func,
    }),

    /* children {JSX} -> JSX wrapped in between button component */
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

    /* className {String} -> overrides the default class property */
    className: PropTypes.string,
}

export default memo(Button)
